import { useContext, useEffect, useMemo, useState, useCallback } from "react";
import { AuthContext } from "context/AuthContext";
import { getDealerList } from "pages/dashboard/distributor/service";
import { useLocation, useSearchParams } from "react-router-dom";
import { throttle } from "lodash";
import { showToast } from "ui/components/common";
import clsx from "clsx";
import { User } from "context/AuthContext";
import PubSub from "pubsub-js";
const PageSize = 20;

export default function DealerList({
  curDealer,
  onDealerSelect,
}: {
  curDealer: User;
  onDealerSelect: (dealer: User) => void;
}) {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const [searchParams] = useSearchParams();

  const [scrollOffset, setScrollOffset] = useState(null);

  const [dealerList, setDealerList] = useState<{ user: User }[]>([]);

  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const queryName = useMemo(() => {
    const params = new URLSearchParams(searchParams);
    console.log("queryString", params.toString());
    return params?.get("query") || "";
  }, [location]);

  useEffect(() => {
    console.log("location changed", location);

    setDealerList([]);
  }, [location.pathname, location.search]);

  useEffect(() => {
    fetchDealerList(user.orgId, queryName || "", 0);
  }, [queryName]);

  useEffect(() => {
    console.log(
      "scrollOffset",
      scrollOffset,
      total,
      offset * PageSize,
      isLoading,
    );
    if (scrollOffset < 5 && total > (offset + 1) * PageSize && !isLoading) {
      handleLoadMore();
    }
  }, [scrollOffset]);

  useEffect(() => {
    const subscription = PubSub.subscribe("dealerCreated", () => {
      fetchDealerList(user.orgId, queryName || "", 0);
    });
    return () => {
      PubSub.unsubscribe(subscription);
    };
  }, []);

  const fetchDealerList = async (
    orgId: string,
    name: string,
    offset: number = 0,
  ) => {
    try {
      setIsLoading(true);
      if (offset === 0) {
        setDealerList([]);
      }
      const res = await getDealerList(orgId, name, offset, PageSize);

      if (res.status !== 200) {
        showToast(1, "Failed to fetch case list. Please try again later.");
        setIsLoading(false);
        return;
      }

      const data = res?.data as {
        data: { user: User }[];
        page: { offset: number; total: number };
      };
      setDealerList((prev) => [...prev, ...data.data]);
      setOffset(offset);
      setTotal(data.page?.total);
    } catch (error) {
      console.error("Failed to fetch case list", error);
      showToast(1, "Failed to fetch case list. Please try again later.");
    }

    setIsLoading(false);
  };

  const handleLoadMore = () => {
    fetchDealerList(user.orgId, queryName, offset + 1);
  };

  const onScroll = useCallback(
    throttle((e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      setScrollOffset(scrollHeight - scrollTop - clientHeight);
    }, 200),
    [],
  );
  console.log("dealerList", dealerList);
  return (
    <div className="w-full pt-4">
      <div
        style={{ maxHeight: "calc(100vh - 170px)", overflowY: "auto" }}
        onScroll={onScroll}
      >
        {dealerList?.map((dealer, index) => (
          <div key={index}>
            <button
              className={clsx(
                "pl-6 py-4 w-full font-semibold  text-left",
                curDealer?.id === dealer?.user?.id
                  ? "bg-[#DCE7FD]"
                  : "hover:bg-[#f5f8fa]",
              )}
              onClick={() => onDealerSelect(dealer?.user)}
            >
              {dealer?.user?.email}
            </button>
          </div>
        ))}
        <div
          className="text-sm text-center text-neutral-500 h-0.5"
          id="needLoadMore"
        />
        {isLoading && (
          <div className="w-full text-center mt-4">
            <button
              onClick={handleLoadMore}
              disabled={isLoading}
              className="rounded-xl bg-white w-[104px] h-10 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            >
              {isLoading ? (
                <div
                  className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                  role="status"
                ></div>
              ) : (
                "Load More"
              )}
            </button>
          </div>
        )}
        {!isLoading &&
          total <= (offset + 1) * PageSize &&
          dealerList?.length == 0 && (
            <p className="text-sm text-center text-neutral-500 pb-3 pt-1">
              No More dealer
            </p>
          )}
      </div>
    </div>
  );
}
